// extracted by mini-css-extract-plugin
export default {"bottom":"DiagramCommentBorder_bottom__-PQDH","right":"DiagramCommentBorder_right__jyPyP"};